import { useCallback } from "react"
import { trpc } from "../../../../api/trpc/trpc"
import { uploadImage } from "../../../../utils/storage"

export function useFileUpload() {
  const getAttachmentUploadUrlMutation = trpc.useMutation("web.getAcquisitionAttachmentUploadUrl", {
    onError: undefined,
  })

  const uploadFile = useCallback(
    async (file: File) => {
      const { objectPath, url } = await getAttachmentUploadUrlMutation.mutateAsync()
      await uploadImage(url, file, false)
      return objectPath
    },
    [getAttachmentUploadUrlMutation]
  )

  return uploadFile
}
